import TablePage from '@/found/components/table_page';
import request from '@/found/utils/request';
import actForm from '@/found/views/tpm/views/activity/marketing_activity/form';

export default {
  extends: TablePage,
  props: {
    propsObj: Object,
  },
  components: {
    actForm,
  },
  data() {
    return {
      formFunctionCode: 'active_list',
      params: { profileCode: this.propsObj.profileCode },
    };
  },
  async created() {
    console.log('thisfff', this.propsObj);
    this.getConfigList('active_list');
  },
  methods: {
    modalClick({ val, row }) {
      console.log(val.code);
      console.log(row);
      if (val.code === 'view') {
        this.formName = 'actForm';
        this.modalConfig.title = '查看';
        this.formConfig = {
          row,
          code: 'view',

        };
        this.openFull();
      }
    },
  },
};
